import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Import useLocation
import Logo from '@assets/images/logo_black.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation(); // Get current location

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Helper to check active path
  const isActive = (path) => location.pathname === path ? "active" : "";

  return (
    <header className={`navbar ${isSticky ? "sticky" : ""}`}>
      <div className="nav-container">
        <div className="line"></div>
        {/* Logo */}
        <div className="logo">
          <a href="/"><img src={Logo} alt="logo" /></a>
        </div>

        {/* Mobile Toggle */}
        <div
          className={`toggle menu-icon ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(true)}
        >
          <span></span><span></span><span></span>
        </div>

        {/* Menu Links */}
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          <button className="close-btn" onClick={() => setMenuOpen(false)}>
            ✕
          </button>

          <li><a href="/projects" className={isActive('/projects')}>PROJECTS</a></li>
          <li><a href="/progress" className={isActive('/progress')}>Progress</a></li>
          <li><a href="/studio" className={isActive('/studio')}>Studio</a></li>
          <li><a href="/moments" className={isActive('/moments')}>Moments</a></li>
          <li><a href="/team" className={isActive('/team')}>Team</a></li>
          <li><a href="/success" className={isActive('/success')}>SUCCESS</a></li>
          <li><a href="/youtube" className={isActive('/youtube')}>YOUTUBE</a></li>
          <li><a href="/contact" className={isActive('/contact')}>CONTACT</a></li>
          <li><a className="highlight" href="/contact">DESIGN YOUR DREAM →</a></li>
        </ul>

      </div>
    </header>
  );
};

export default Navbar;
